export const {
  getDiscountPeriodsForAccount,
  fetchCouponCodeTypes,
  fetchBusinessDetailsPage,
  fetchBraintrustPlatformConfig,
} = require('./partnerQueriesGraphQL');
